module.exports = __webpack_public_path__ + "images/vintage-9deb1a36deacde42238828a0d26c41ea.jpg";